import { DEFAULT_CONFIGS } from "./defaults.js";
import { VIDEO_TYPE } from "./types.js";
import { nodeViewRenderers } from "./viewer/loadable/node-view-renderers-loadable.js";
const pluginVideo = (config) => {
  return {
    config: { ...DEFAULT_CONFIGS.viewer, ...config },
    type: VIDEO_TYPE,
    nodeViewRenderers
  };
};
export {
  pluginVideo
};
//# sourceMappingURL=viewer-loadable.js.map
